import React, { useState, useEffect, useRef } from "react";
import "../../CSS/Employes.css";
import { Toaster, toast } from "react-hot-toast";
import { API_BASE_URL } from "../../config/serverApiConfig";
import Select, { GroupBase, StylesConfig } from "react-select";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import chroma from "chroma-js";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import {
  ColourOption,
  colourOptions,
  colourOptionsFetes,
  fromPerson,
} from "../../Selecteddata/data";
import { format } from "date-fns";
import { Calendar } from "react-date-range";
import Cookies from "js-cookie";
import { getCookie } from "../../auth/cookie";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const EmployeeDataFormat = {
  candidatName: "",
  candidatEmail: "",
  candidatPhone: "",
  candidatAddress: "",
  candidatActivitySector: "",
  candidatJob: "",
  candidatFBURL: "",
  candidatAlternatePhone: "",
  candidatSkills: "",
  candidatAge: 0,
  candidatMotivation: 0,
  candidatLanguages: [],
  candidatLicensePermis: false,
  candidatConduireEnFrance: false,
  candidatStartDate: "",
  candidatComingFrom: [],
  candidatEndDate: "",
  candidatYearsExperience: "",
  candidatFetes: [],
  candidatPhoto: "",
  candidatExperienceDetails: [
    {
      period: "",
      location: "",
      workDoneSample: "",
    },
  ],
  candidatCurrentWork: [
    {
      workingFor: "",
      workingSince: "",
      salary: "",
    },
  ],
  enteredBy: "",
  candiatStatus: "New",
  candidateArchived: {
    reason: "",
  },
};

export default function Employes() {
  const [data, setData] = useState(EmployeeDataFormat) as any;
  const [jobs, setJobs] = useState([
    { jobName: "", associatedSector: "", _id: "" },
  ]);
  const currentIntermannUser = JSON.parse(localStorage.getItem("LoginUser"));

  const [activitySectors, setActivitySectors] = useState([]);
  const [languages, setLangauges] = useState([]);
  const [fetes, setFetes] = useState([]);
  const [period, setPeriod] = useState("");
  const [location, setLocation] = useState("");
  const [workDoneSample, setWorkDoneSample] = useState("");
  const [Language, setLanguage] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [selectedSector, setSelectedSector] = useState("");
  const [dsBtn, setdsBtn] = useState(false);
  const [showError, setShowError] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(false);
  const [jobOptions, setJobOptions] = useState([]);
  const [displayRow, setDisplayRow] = useState(false);
  const [contactErr, setcontactErr] = useState([]);
  const [sectorOption, setSectorOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [Startopen, setStartOpen] = useState(false);
  const [owners, setOwners] = useState([]);
  const [ownersOptions, setOwnersOptions] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState("");
  // Editor for multi skills
  const [skills, setSkills] = useState([{
    value: "",
    editorValue: "",
    date: format(new Date(), "dd/MM/yyyy")
  }])

  const [workExperience, setWorkExperience] = useState([
    {
      period: "",
      location: "",
      workDoneSample: "",
    },
  ]);
  const refOne = useRef(null);
  const reftwo = useRef(null);
  useEffect(() => {
    // event listeners

    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
  }, []);

  // hide dropdown on ESC press
  const hideOnEscape = (e) => {
    // console.log(e.key)
    if (e.key === "Escape") {
      setOpen(false);
    }
    if (e.key === "Escape") {
      setStartOpen(false);
    }
  };
  const hideOnClickOutside = (e) => {
    // console.log(refOne.current)
    // console.log(e.target)
    if (refOne.current && !refOne.current.contains(e.target)) {
      setOpen(false);
    }
    if (reftwo.current && !reftwo.current.contains(e.target)) {
      setStartOpen(false);
    }
  };
  const dateChange = (date) => {
    setData({ ...data, ["candidatEndDate"]: format(date, "dd-MM-yyyy") });
    setStartOpen(false);
  };
  const dateChangeStart = (date) => {
    setData({ ...data, ["candidatStartDate"]: format(date, "dd-MM-yyyy") });
    setOpen(false);
  };
  const fetchOwners = async () => {
    return await fetch(API_BASE_URL + `allusers`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
    })
      .then((red) => red.json())
      .then((resData) => resData)
      .catch((err) => err);
  };
  const colourStyles: StylesConfig<ColourOption, true> = {
    control: (styles) => ({ ...styles, backgroundColor: "white", padding: '5px', borderRadius: '20px' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = chroma(data.color);
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
            ? data.color
            : isFocused
              ? color.alpha(0.1).css()
              : undefined,
        color: isDisabled
          ? "#ccc"
          : isSelected
            ? chroma.contrast(color, "white") > 2
              ? "white"
              : "black"
            : data.color,
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : color.alpha(0.3).css()
            : undefined,
        },
      };
    },
    multiValue: (styles, { data }) => {
      const color = chroma(data.color);
      return {
        ...styles,
        backgroundColor: color.alpha(0.1).css(),
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: data.color,
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: data.color,
      ":hover": {
        backgroundColor: data.color,
        color: "white",
      },
    }),
  };

  // Notifications //
  const notifyCandidatAddSuccess = () =>
    toast.success("Candidate Added Successfully! View Candidate in the Candidates List.");

  const notifyCandidatAddError = () =>
    toast.error("Candidate Cannot Be Added! Please Try Again.");

  const notifyNameError = () => toast.error("Please Provide Candidate Name!");

  const notifyActivitySectorError = () =>
    toast.error("Ajouter les Secteur D'Activite et Le Job pour Candidat!");

  const notifyAddressError = () =>
    toast.error("Please Provide Candidate Address !");

  const wherePerson = (selectedOption) => {
    let PersonFromarr = [];

    selectedOption.map((el) => {
      PersonFromarr.push(el.value);
    });
    setData({ ...data, candidatComingFrom: PersonFromarr });
  };

  const handleChange = (selectedOption) => {
    let arr = [];

    selectedOption.map((el) => {
      arr.push(el.value);
    });
    setLanguage(arr);
    console.log(Language, "language");
    setData({ ...data, candidatLanguages: arr });
  };
  const FetesDate = (selectedOption: any) => {
    let FetesArr = [];
    selectedOption?.map((el) => {
      FetesArr.push(el.value);
    });

    setData({ ...data, candidatFetes: FetesArr });
  };

  const handleOwnerChange = (e: any) => {
    console.log(e.value);
    setData({ ...data, enteredBy: e.value });
    setSelectedOwner(e.value);
  }

  const handleSectorChange = async (e: any) => {
    setJobs([]);
    if (e.value !== "") {
      let sectorField = e.value;
      setSelectedSector(sectorField);
      await changeSectorSelection(sectorField);
      setData({ ...data, candidatActivitySector: sectorField });
    }
  };

  useEffect(() => {
    if (activitySectors.length == 0) {
      fetchActivitySectors()
        .then((reData) => {
          setActivitySectors([...reData.data]);
        })
        .catch((err) => console.log(err));
    }
    if (sectorOption.length == 0) {
      let sectorops = activitySectors.map((asector) => {
        return {
          value: asector.sectorName,
          label: asector.sectorName,
          color: "#FF8B00",
        };
      });

      setSectorOptions([...sectorops]);
    }
  }, [activitySectors]);

  useEffect(() => {
    if (!owners.length) {
      fetchOwners()
        .then((ownersData) => {
          console.log(ownersData);
          setOwners([...ownersData.data])
        })
        .catch(err => console.log(err));
    }
    if (ownersOptions.length === 0) {
      const ownersOps = owners.map((owner) => {
        return {
          value: owner.username,
          label: owner.username,
          color: "#FF8B00",
        };
      })

      setOwnersOptions([...ownersOps]);
    }
  }, [owners]);

  const fetchAllJobs = async (sector: string) => {
    return await fetch(API_BASE_URL + `fetchAllJobs/?sector=${sector}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
    })
      .then((resD) => resD.json())
      .then((reD) => reD)
      .catch((err) => err);
  };

  const fetchActivitySectors = async () => {
    return await fetch(API_BASE_URL + "fetchAllSectors", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
    })
      .then((resp) => resp.json())
      .then((respData) => respData)
      .catch((err) => err);
  };

  const checkCandidatName = async (name: any) => {
    return await fetch(
      API_BASE_URL + `checkCandidatName/?candidatName=${name}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((reD) => reD)
      .catch((err) => err);
  };

  const checkCandidatePhone = async (num: any) => {
    return await fetch(
      API_BASE_URL +
      `checkCandidatExists/?candidatPhone=${num.replace("+", "")}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((reD) => reD)
      .catch((err) => err);
  };

  const saveCandidatData = async () => {
    return await fetch(API_BASE_URL + "addCandidat", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
      body: JSON.stringify({ ...data, candidatSkills: JSON.stringify(skills) }),
    })
      .then((resp) => resp.json())
      .then((reD) => reD)
      .catch((err) => err);
  };

  const addWorkExperience = (e: any) => {
    e.preventDefault();
    if (period == "") {
      return;
    }

    setWorkExperience([
      ...workExperience,
      { period: "", location: "", workDoneSample: "" },
    ]);

    setDisplayRow(true);
    console.log(data);
  };

  const cancelWorkExperience = () => {
    const wex = workExperience.filter((workex) => {
      return workex.period != "";
    });
    console.log(wex);
    setWorkExperience([...wex]);
    setDisplayRow(false);
    setInputDisabled(true);
  };

  const onFormDataChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | any
    >
  ) => {
    setData((prev) => ({ ...prev, ["enteredBy"]: currentIntermannUser?.username }));
    if (e.target.name === "candidatActivitySector") {
      console.log(e.target.name, e.target.value);
      changeSectorSelection(e.target.value);
    }
    if (e.target.name === "candidatName") {
      console.log(e.target.value);
      checkCandidatName(e.target.value.toLocaleUpperCase())
        .then((resData) => {
          console.log(resData);
          if (resData.status) {
            setShowError(true);
          } else {
            setShowError(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      let val = e.target.value.toLocaleUpperCase();
      setData((prev) => ({ ...prev, ["candidatName"]: val }));
      return;
    }
    if (e.target.name === "candidatPhone") {
      checkCandidatePhone(e.target.value.replace(" ", ""))
        .then((res) => {
          console.log(res, "res");
          if (res.status) {
            setcontactErr([...res.data]);
          } else {
            setcontactErr([]);
          }
        })
        .catch((err) => err);
    }
    if (e.target.name === "candidatMotivation") {
      changeSectorSelection(e.target.value);
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
      }, 2500);
    }
    if (e.target.name === "candidatLanguages") {
      if (e.target?.value) {
        addLanguages(e.target.value);
        return;
      } else {
        removeLanguages(e.target.value);
        return;
      }
    }
    if (e.target.name === "period") {
      setPeriod(e.target.value);
      return;
    }
    if (e.target.name === "location") {
      setLocation(e.target.value);
      return;
    }
    if (e.target.name === "workDoneSample") {
      setWorkDoneSample(e.target.value);
      if (e.target.value) {
        setDisplayRow(true);
      }
      return;
    }
    if (e.target.name === "candidatFetes") {
      if (e.target?.value) {
        addFetes(e.target.value);
        return;
      } else {
        removeFetes(e.target.value);
        return;
      }
    }
    if (e.target.name === "candidatStartDate") {
      var tempDate = new Date(e.target.value);
      var formattedDate = [
        tempDate.getDate(),
        tempDate.getMonth() + 1,
        tempDate.getFullYear(),
      ].join("-");
      setData((prev) => ({ ...prev, ["candidatStartDate"]: formattedDate }));
    } else if (e.target.name === "candidatEndDate") {
      var tempDate = new Date(e.target.value);
      var formattedDate = [
        tempDate.getDate(),
        tempDate.getMonth() + 1,
        tempDate.getFullYear(),
      ].join("-");
      setData((prev) => ({ ...prev, ["candidatEndDate"]: formattedDate }));
    } else {
      setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }

  };

  const onFormTableDataChange = (event: any, index: any) => {
    const { name, value } = event.target
    let updatedData = [...workExperience]
    updatedData[index][name] = value
    setWorkExperience([...updatedData]);
  }
  useEffect(() => {
    // console.log(period, location, workDoneSample, data);
  }, [period, location, workDoneSample]);

  useEffect(() => {
    const wex = workExperience.filter((workex) => {
      return (
        workex.period != "" &&
        workex.location != "" &&
        workex.workDoneSample != ""
      );
    });
    setData((prev) => ({ ...prev, ["candidatExperienceDetails"]: wex }));
  }, [workExperience]);

  const addFetes = (fete: string) => {
    setFetes((prev) => [...prev, fete]);
    setData((prev) => ({ ...prev, ["candidatFetes"]: [...fetes, fete] }));
  };

  const removeFetes = (fete: string) => {
    setFetes(fetes.filter((f) => f !== fete));
    setData((prev) => ({
      ...prev,
      ["candidatFetes"]: [...fetes.filter((f) => f !== fete)],
    }));
  };

  useEffect(() => {
    // console.log(data, fetes);
  }, [fetes]);

  const addLanguages = (lang: string) => {
    setLangauges((prev) => [...prev, lang]);
    setData((prev) => ({
      ...prev,
      ["candidatLanguages"]: [...languages, lang],
    }));
  };

  const removeLanguages = (lang: string) => {
    setLangauges(languages.filter((l) => l !== lang));
    setData((prev) => ({
      ...prev,
      ["candidatLanguages"]: [...languages.filter((l) => l !== lang)],
    }));
  };

  useEffect(() => {
    // console.log(data, languages);
  }, [languages]);

  const changeSectorSelection = async (sec: string) => {
    if (sec) {
      await fetchAllJobs(sec)
        .then((data) => {
          setJobs([...data.data]);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const jobChange = async (jobval) => {
    // console.log(jobval)
    let JobArr = "" as any;

    JobArr = jobval.value;

    setData({ ...data, candidatJob: JobArr });

    // changeJobSelection(JobArr)
  };

  // Trigger job options update whenever jobs state changes
  useEffect(() => {
    let jobResults = !jobs.length
      ? []
      : jobs.map((ajob) => ({
        value: ajob.jobName,
        label: ajob.jobName,
        color: "#FF8B00",
      }));

    setJobOptions([...jobResults]);
  }, [jobs]);

  const onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    setdsBtn(true);
    e.preventDefault();

    if (data.candidatName == "") {
      notifyNameError();

      setdsBtn(false);

      return false;
    }

    console.log(data);

    saveCandidatData()
      .then((data) => {
        if (data.status) {
          notifyCandidatAddSuccess();
          setdsBtn(false);
          setTimeout(() => {
            window.location.href = "/addCandidate";
          }, 2000);
        } else {
          notifyCandidatAddError();
          setdsBtn(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const selectionRange = {
    startDate: new Date(),
    endDate: "",
    key: "selection",
  };

  // notes multi
  const handleAddNote = () => {
    setSkills([...skills, { editorValue: "", value: "", date: format(new Date(), 'dd/MM/yyyy') }])
  };

  return (
    <>
      {" "}
      <Toaster position="bottom-right" />
      <div className="container-fluid px-2">
        <div className="row">
          <div
            className="col-12 card-tops px-1 mt-2"
            style={{ padding: "0px", marginBottom: "20px" }}
          >
            <div className="row text-start">
              <div
                className="card "
                style={{
                  height: "77px",
                  borderRadius: "15px",
                  marginBottom: "0px",
                }}
              >
                <div className="card-body d-flex align-items-center">
                  <h2 className="card-Leads mb-0">
                    Add a candidats / employes
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 p-0">
            <div className="row px-1 pb-1">
              <form
                className="add-form form needs-validation p-0"
                name="contact-form"
                onSubmit={onFormSubmit}
                noValidate
              >
                <div className="d-flex flex-wrap justify-content-around employes-add-container">
                  <div className="col-4 ">
                    <div className="p-1">
                      <label
                        className="Form-styling"
                        htmlFor="validationCustom01"
                      >
                        Candidate's Name
                      </label>
                      <input
                        type="text"
                        className="form-control nameTransform"
                        placeholder="Enter candidats name"
                        id="validationCustom01"
                        name="candidatName"
                        required
                        value={data.candidatName.toLocaleUpperCase()}
                        onChange={onFormDataChange}
                      />

                      {showError ? (
                        <p
                          style={{ color: "#FE8700", overflow: "hidden" }}
                          className="text-small"
                        >
                          ⚠️ Attention ! Un autre profil avec le meme nom existe
                          déjà !
                        </p>
                      ) : null
                      }
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="p-1">
                      <label className="Form-styling">Candidate's Email</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter email"
                        name="candidatEmail"
                        value={data.candidatEmail}
                        onChange={onFormDataChange}
                      />

                    </div>
                  </div>
                  <div className="col-4">
                    <div className="p-1">
                      <label className="Form-styling">
                        Candidat's Phone Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Phone Number (+format)"
                        name="candidatPhone"
                        required
                        value={data.candidatPhone}
                        onChange={onFormDataChange}
                      />

                      {contactErr.length > 0 ? (
                        <span
                          style={{ color: "#FE8700", overflow: "hidden" }}
                          className="text-small"
                        >
                          ⚠️ This name already exists on database, please check
                          if it's not a doublon.
                        </span>
                      ) : null
                      }
                    </div>
                  </div>

                  <div className="col-4">
                    <div className="p-1">
                      <label className="Form-styling">Sector Of Activity</label>
                      <Select
                        options={sectorOption}
                        onChange={handleSectorChange}
                        styles={colourStyles}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        closeMenuOnSelect={true}
                        placeholder="Select An Activity Sector"
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="p-1">
                      <label className="Form-styling">Profession</label>

                      {jobOptions.length > 0 ? (
                        <Select
                          name="jobName"
                          closeMenuOnSelect={true}
                          placeholder="Select A Profession"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={jobChange}
                          options={jobOptions}
                          styles={colourStyles}
                        />
                      ) : (
                        <div className="d-flex justify-content-center my-1">
                          <div
                            className="spinner-grow text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <div
                            className="spinner-grow text-secondary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <div
                            className="spinner-grow text-success"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <div className="spinner-grow text-danger" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <div
                            className="spinner-grow text-warning"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <div className="spinner-grow text-dark" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-4">
                    <div className="p-1">
                      <label className="Form-styling">Candidat's Age </label>
                      <input
                        type="number"
                        className="form-control"
                        name="candidatAge"
                        placeholder="42"
                        value={data.candidatAge}
                        onChange={onFormDataChange}
                      />
                    </div>
                  </div>
                  <div className="col-5">
                    <div className="p-1">
                      <label className="Form-styling">Owner Of The Lead</label>
                      <Select
                        options={ownersOptions}
                        onChange={handleOwnerChange}
                        styles={colourStyles}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        closeMenuOnSelect={true}
                        placeholder="Select Owner of this Lead"
                      />
                    </div>
                  </div>

                  <div className="col-7">
                    <div className="p-1">
                      <p className="padding-bottom Form-styling">
                        Candidat's Languages
                      </p>

                      <div className="languages-selector">
                        <Select
                          name="candidatLanguages"
                          closeMenuOnSelect={false}
                          isMulti
                          placeholder="Select"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={handleChange}
                          options={colourOptions}
                          styles={colourStyles}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-5 p-1">
                    <label className="fw-bold Form-styling">
                      When this candidate is ready to work with us
                    </label>
                    <div className="dateStart">
                      <label className="Form-styling">
                        FROM DATE
                      </label>
                      <input
                        value={
                          data.candidatStartDate === ""
                            ? "dd/mm/yyyy"
                            : data.candidatStartDate
                        }
                        readOnly
                        style={{ textTransform: "none" }}
                        className="dateSort"
                        onClick={() => setStartOpen((open) => !open)}
                      />
                      <div
                        ref={reftwo}
                        className="rdrDateRangePickerWrapper "
                      >
                        {Startopen && (
                          <Calendar
                            onChange={(item) => dateChangeStart(item)}
                            direction="vertical"
                            className="calendarElement "
                          />
                        )}
                      </div>
                      <div
                        onClick={() => setStartOpen((open) => !open)}
                        className="d-flex justify-content-end eventPos"
                      >
                        <img
                          alt="..."
                          src={
                            require("../../images/event.svg").default
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-7 p-1">
                    <p className="Form-styling">Driver License</p>
                    <div className="d-flex radiobtn">
                      <ul className="d-flex permis-UL p-0">
                        <li className="permis-LI">
                          <input
                            type="radio"
                            id="f-option"
                            name="candidatLicensePermis"
                            value="true"
                            onChange={onFormDataChange}
                          />
                          <label htmlFor="f-option">
                            <p className="text-white">Yes</p>
                          </label>
                          <div className="check"></div>
                        </li>
                        <li className="permis-LI mx-1">
                          <input
                            type="radio"
                            id="t-option"
                            name="candidatLicensePermis"
                            value="false"
                            onChange={onFormDataChange}
                          />
                          <label htmlFor="t-option">
                            <p className="text-white">No</p>
                          </label>

                          <div className="check">
                            <div className="inside"></div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-12 p-1">
                    <p className="Form-styling">Experience of the candidate:</p>
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th scope="col">
                            Example Period: Jan 2020 to Jan 2021
                          </th>
                          <th scope="col">Workplace Example: Paris</th>
                          <th scope="col">
                            Work carried out Example: Facadier Insulator
                          </th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {workExperience.length > 0 ?
                          workExperience.map((workex, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="text"
                                  value={workex.period}
                                  name="period"
                                  className="form-control"
                                  placeholder="Years"
                                  onChange={(event) => onFormTableDataChange(event, index)}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  value={workex.location}
                                  name="location"
                                  className="form-control"
                                  placeholder="Work Location"
                                  onChange={(event) => onFormTableDataChange(event, index)}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  value={workex.workDoneSample}
                                  name="workDoneSample"
                                  className="form-control"
                                  placeholder="Work Done Sample"
                                  onChange={(event) => onFormTableDataChange(event, index)}
                                />
                              </td>
                              <td className="d-flex">
                                <button type="button"
                                  onClick={() => {
                                    let newArr = []
                                    newArr = workExperience.filter((fl, i) => i !== index)
                                    setWorkExperience([...newArr])
                                  }} className="btn experience-action-button">  <img alt="..." src={require("../../images/Deletebucket.svg").default} /></button>
                                <button type="button" onClick={() => {
                                  let newArr = [...workExperience]
                                  newArr.push({ period: "", location: "", workDoneSample: "" })
                                  setWorkExperience([...newArr])
                                }} className="btn experience-action-button"><svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14m-7 7V5" />
                                  </svg>
                                </button>
                              </td>
                            </tr>
                          )) :
                          <tr >
                            <td>
                              <input
                                type="text"
                                value={period}
                                name="period"
                                className="form-control"
                                placeholder="Years"
                                onChange={(event) => setPeriod(event.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={location}
                                name="location"
                                className="form-control"
                                placeholder="Work Location"
                                onChange={(event) => setLocation(event.target.value)}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={workDoneSample}
                                name="workDoneSample"
                                className="form-control"
                                placeholder="Work Done Sample"
                                onChange={(event) => setWorkDoneSample(event.target.value)}
                              />
                            </td>
                            <td className="d-flex">
                              <button type="button" onClick={() => {
                                let newArr = []
                                newArr.push({ period: period, location: location, workDoneSample: workDoneSample })
                                setWorkExperience([...newArr])
                              }} className="btn"><svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14m-7 7V5" />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>

                  <div className="col-12 rounded px-2" >
                    <div className="row px-2" style={{ border: "1px solid #E5E7F0", borderRadius: "10px", justifyContent: "space-between", boxShadow: "rgb(0, 0, 0) 0px 3px 10px -3px" }}>
                      <div className="col-12">
                        <div className="mt-2">
                          <h5 className="mb-2" style={{ fontWeight: "bold" }}>Add Notes</h5>
                        </div>
                      </div>

                      {
                        skills?.map((el: any, index: any) => (
                          <div className="col-6 editor-add-page-skills" >
                            <div className="d-flex flex-column">
                              <label className="text-black">Note Date: <span className="fw-bold">{el?.date}</span></label>
                              <label className="text-black">Note Added By: <span className="fw-bold">{selectedOwner}</span></label>
                            </div>
                            <Editor

                              defaultEditorState={el.editorValue}
                              toolbarClassName="toolbarClassName"
                              wrapperClassName="wrapperClassName"
                              editorClassName="editorClassName"
                              onEditorStateChange={(newState: any) => {
                                skills[index].editorValue = newState;
                                skills[index].value = draftToHtml(
                                  convertToRaw(newState.getCurrentContent())
                                );

                                setSkills(skills);

                              }}
                            />
                          </div>
                        ))
                      }



                      <div className="d-flex justify-content-end mt-2 mb-2">
                        <button
                          type="button"
                          style={{ background: "white" }} className="btn custom-cancel-button  text-secondary px-4 mr-2 custom-cancel-button btn-CVManual"
                          onClick={() => {
                            if (skills.length !== 1) {
                              setSkills(skills.filter((fl, i) => i !== (skills.length - 1)))
                            }

                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-CVManual text-white px-4"
                          onClick={handleAddNote}
                        >
                          Add New Note
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 py-4 d-flex justify-content-center px-2">
                    <button
                      disabled={dsBtn}
                      className="btn btn-dark btn-stylingEnd"
                      type="submit"
                    >
                      Add this candidate
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
